// extracted by mini-css-extract-plugin
module.exports = {"root":"hint-module--root--3OGKq","collapsed":"hint-module--collapsed--w7Cr2"};